import * as React from 'react';
import { Typography } from 'antd';
import s from './Header.module.less';

type Props = {
  children: React.ReactNode;
};

const Header = ({ children }: Props) => (
  <Typography.Title className={s.title} level={3}>
    {children}
  </Typography.Title>
);

export default Header;
